var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{ 'is-online': _vm.isOnline, 'is-offline': !_vm.isOnline, 'no-video-object-fit': !_vm.supportsObjectFitOnVideos },attrs:{"id":"app"}},[(!_vm.loading)?_c('router-view'):_vm._e(),_vm._v(" "),(_vm.loading)?_c('LoadingAnimation',{staticClass:"app__loading-animation"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }